const initialState = {
  show: false,
};

const nav = ( state = initialState, action ) => {
	// must return the same state or an updated version of the state
	const actionLookup = {
    // set the default filters available
    'TOGGLE_NAV': () => ({
      ...state, 
      show: action.show
    }), 
  };
  return actionLookup[action.type] ? actionLookup[action.type](state, action) : {...state}; // if the action type exists, execute action, otherwise returns default state
};

export default nav;


// WEBPACK FOOTER //
// ./src/store/reducers/nav.js